import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import useScrollToTop from '../../hooks/useScrollToTop'
import { getNewsId } from '../../utils/API/getnewsbyid'
import NewsFeed from '../organisms/NewsFeed'
import { Skeleton } from 'antd'

const NewsDescription = () => {
  useScrollToTop()
  const { id } = useParams()
  const [newsItem, setNewsItem] = useState(null)

  useEffect(() => {
    const fetchNewsById = async () => {
      try {
        const response = await getNewsId(id)
        if (response.success) {
          setNewsItem(response.data)
        } else {
          console.error('Error fetching news by ID:', response.message)
        }
      } catch (error) {
        console.error('Error fetching news by ID:', error)
      }
    }

    fetchNewsById()
  }, [id])

  if (!newsItem) {
    return (
      <div className='flex flex-col gap-y-4 p-4'>
        <Skeleton.Button block={true} active={true} />
        <Skeleton.Button block={true} active={true} />
        <Skeleton.Button block={true} active={true} />
        <Skeleton.Button block={true} active={true} />
      </div>
    )
  }

  const { cover_img_src, main_heading_title, category_name, description } =
    newsItem

  return (
    <>
      <div className='w-full flex '>
        <div>
          <div className='w-full h-full bg-[#F4F6FA]'>
            <div className='pt-6 mr-16'>
              <h1 className='text-2xl ml-7 font-bold'>News</h1>
              <img
                className='mx-5 mt-4 w-[980px] h-[366px] rounded-lg'
                src={cover_img_src}
                alt='Cover Image'
              />
              <div className='flex justify-between pt-16 pl-4'>
                <h1 className='text-2xl font-bold'>{main_heading_title}</h1>
                <h1 className='text-xl font-bold text-blue-800'>
                  {category_name}
                </h1>
              </div>
              <div className="px-4" dangerouslySetInnerHTML={{ __html: description }} />
              
            </div>
          </div>
        </div>
        <div className='pt-6 bg-[#F4F6FA] '>
          <NewsFeed />
        </div>
      </div>
    </>
  )
}

export default NewsDescription
